import { makeAutoObservable } from "mobx";
import { filterTagsGl } from "./FilterTags";
export default interface ITagWithRelated {
  id: number;
  name: string;
  tagCounter: number;
  related: {
    id: number;
    distance: number;
  }[];
}
export class Tags {
  public listOfTags: ITagWithRelated[] = [];
  public tagsIsLoading: boolean = false;
  constructor() {
    makeAutoObservable(this);
  }
  /**
   * Установить список тэгов
   * @param tags
   */
  public setListOfTags(tags: ITagWithRelated[]) {
    this.orderBySelected(tags);
    // tags.forEach((tag: ITagWithRelated) => {
    //   if (!this.listOfTags.map((t) => t.id).includes(tag.id)) {
    //     this.listOfTags.push(tag);
    //   } else {
    //     tagsStore.listOfTags.forEach((storeTag, index) => {
    //       if (storeTag.id == tag.id) {
    //         this.listOfTags[index] = { ...tag };
    //       }
    //     });
    //   }
    // });
  }
  /**
   * Сначала - выбранные тэги
   */
  public orderBySelected(tags: ITagWithRelated[]) {
    this.listOfTags = [
      ...tags.sort((a: ITagWithRelated, b: ITagWithRelated) => {
        const isASelected = filterTagsGl.listOfSelectedTags.filter(
          (subTag) => subTag.id == a.id
        ).length;
        const isBSelected = filterTagsGl.listOfSelectedTags.filter(
          (subTag) => subTag.id == b.id
        ).length;
        if (isASelected) {
          return -1;
        } else if (isBSelected) {
          return 1;
        }
        return 0;
      }),
    ];
  }
}
export const tagsStore = new Tags();
